export default {
    body: {
        background: '#000',
        text: '#888',
        headers: '#FFF',
    },
    colors: {
        black: '#000',
        white: '#FFF',
        gray: '#7A839A',
        primary: '#3ABDA7',
        primaryDark: '#2A9D8A',
    },
    queries: {
        mobile: '725px',
        tablet: '900px',
        desktop: '1150px',
    },
    transition: 'all cubic-bezier(0.16, 0.8, 0.45, 1) 0.25s',
    typography: {
        font: 'system-ui',
        fontSize: '20px',
        fontWeight: '400',
        fontLineHeight: '1.6',
        fontLetterSpacing: '1px',
        headerWeight: '600',
    },
};
